import React from 'react'
import styled from 'styled-components'
import { Flex, Text, TextVariant } from '@mprolab/uikit'
import { ArrowLeft } from 'react-feather'
import { useNavigate, useParams } from 'react-router-dom'
import MainWrapper from 'layouts/MainWrapper'
import { StyledBiennale } from 'components'
import { MarkdownBody } from 'views/Documentation/MarkdownBody'
import { useGetNewsItemQuery } from 'state/services/community/community'

const Column = styled(Flex)`
  width: 100%;
  flex-direction: column;
  margin: 152px 0 120px;
  max-width: 820px;
`

const Title = styled(StyledBiennale)`
  font-size: 32px;
  line-height: 1.15;
`

const Meta = styled(Text)`
  opacity: 0.6;
  margin: 8px 0 20px;
`

const Back = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  align-self: flex-start;
  margin-bottom: 20px;
  padding: 8px 14px;
  border-radius: 999px;
  border: 1px solid ${({ theme }) => theme.colors.gray8};
  background: transparent;
  color: ${({ theme }) => theme.colors.white};
  font-size: 13px;
  cursor: pointer;
`

const Article = styled(Flex)`
  flex-direction: column;
  width: 100%;
  padding: 28px;
  border: 1px solid ${({ theme }) => theme.colors.gray8};
  border-radius: 12px;
  background: ${({ theme }) => theme.colors.background};
`

/**
 * One note, in full.
 *
 * The front page carries an opening and a link; this is where the rest lives.
 * Public and unauthenticated, like the page that links to it — a note somebody
 * shares should open for whoever they shared it with.
 */
const NewsDetail: React.FC = () => {
  const { id = '' } = useParams()
  const navigate = useNavigate()
  const { data, isLoading, isError } = useGetNewsItemQuery({ id }, { skip: !id })

  return (
    <MainWrapper>
      <Column>
        <Back onClick={() => navigate('/')}>
          <ArrowLeft size={15} /> Community news
        </Back>

        {isLoading && <Meta variant={TextVariant.BODY_SMALL}>Loading…</Meta>}
        {!isLoading && isError && (
          <Meta variant={TextVariant.BODY_SMALL}>Could not load this note just now.</Meta>
        )}
        {!isLoading && !isError && !data && (
          <>
            <Title>Not here</Title>
            <Meta variant={TextVariant.BODY_SMALL}>
              This note has been taken down, or the link is wrong.
            </Meta>
          </>
        )}
        {data && (
          <Article>
            <Title>{data.title}</Title>
            <Meta variant={TextVariant.TEXT_XS_REGULAR}>
              {data.publishedAt ? new Date(data.publishedAt).toLocaleDateString() : ''}
              {data.byline ? ` · ${data.byline}` : ''}
            </Meta>
            <MarkdownBody markdown={data.body} />
          </Article>
        )}
      </Column>
    </MainWrapper>
  )
}

export default NewsDetail
